<template>
  <div class="game-screen">
    <header>
      <div class="header-content">
        <div class="player player--one">
          <div class="profile-image"><img :src="playersDetails.homePlayerAvatar" alt=""></div>
          <div class="player__info">
            <div class="player__info__name">{{ playersDetails.homePlayerUsername }}</div>
            <div class="player__info__score">
              <ul>
                <li v-for="(item, index) in numberOfQuestionsPerRound" :key="index" :class="getHomePlayerAnswersHistory(index)"></li>
              </ul>
            </div>
          </div>
        </div>

          <div class="game-timer">
        <div class="game-timer__circle">
          <link href="https://fonts.googleapis.com/css?family=Raleway:400,300,600,800,900" rel="stylesheet" type="text/css">
          <div id="container"></div>
        </div>
          <div class="game-timer__score">
            <span>{{ homeCorrectAnswers }}</span>-<span>{{ awayCorrectAnswers }}</span>
          </div>
        </div>
        <div class="player player--two">
          <div class="player__info">
            <div class="player__info__name">{{ playersDetails.awayPlayerUsername }}</div>
            <div class="player__info__score">
              <ul>
                <li v-for="(item, index) in numberOfQuestionsPerRound" :key="index" :class="getAwayPlayerAnswersHistory(index)"></li>
              </ul>
            </div>
          </div>
          <div class="profile-image"><img :src="playersDetails.awayPlayerAvatar" alt=""></div>
        </div>
      </div>
    </header>
    <section class="game-main">
      <div class="game-main__category">
        <span style="border-color:#1abc9c"></span>
      </div>
      <div class="game-q-container">
        <div class="game-main__question">
          <div class="game-main__question__text">
            <p>{{ personalizedData.questionText }}</p>
          </div>
          <div v-if="personalizedData.imageURL"
               class="game-main__question__image"
               :style="getQuestionImage">
          </div>
        </div>
        <div v-if="personalizedData"
             class="game-main__answers">
          <div v-for="row in (randomizedAnswers.length / 2)"
               :key="row"
               class="game-main__answers__row">
            <button v-for="answer in getPartOfAnswers(row)"
                    :key="answer.answerId"
                    @click="registerUserAnswer(answer.answerId, answer.answerKey, true)"
                    :class="getAnswerCSSClasses(answer)"
                    :disabled="getAnswerCSSClasses(answer).toString() === 'btn,rejected' || timeIsUp">
              <span>{{ answer.answerText }}</span>
              <div>
                <img v-if="isHomePlayer && (homePlayerAnswer === answer.answerKey)"
                     class="p1"
                     :src="playersDetails.homePlayerAvatar"
                     alt="">
                <img v-else-if="!isHomePlayer && (awayPlayerAnswer === answer.answerKey)"
                     class="p2"
                     :src="playersDetails.awayPlayerAvatar"
                     alt="">
                <img v-if="isHomePlayer && bothPlayersAnswered && (awayPlayerAnswer === answer.answerKey)"
                     class="p2"
                     :src="playersDetails.awayPlayerAvatar"
                     alt="">
                <img v-else-if="!isHomePlayer && bothPlayersAnswered && (homePlayerAnswer === answer.answerKey)"
                     class="p1"
                     :src="playersDetails.homePlayerAvatar"
                     alt="">
              </div>
            </button>
          </div>
        </div>
        <div class="game-main__bottom">

            <button @click.prevent="useCheatHelp"
                    :disabled="(cheatUsed || displayedAnswerTime === 0 || timeIsUp)"
                    :class="['btn', 'cheat-btn', (cheatUsed || displayedAnswerTime === 0) ? 'inactive' : 'active']">{{ getTranslations.home_game_cheat }}<i class="icon-magic"></i></button>
            <button @click.prevent="useFiftyFiftyHelp"
                    :disabled="(fiftyFiftyUsed || displayedAnswerTime === 0 || timeIsUp)"
                    :class="['btn', 'fifty-btn', (fiftyFiftyUsed || displayedAnswerTime === 0) ? 'inactive' : 'active']"><i class="icon-dice"></i>50/50</button>

        </div>
      </div>
    </section>
    <component
      :is="currentModal"
      v-on:updateNormalTransitionAndStartNewGame="updateNormalTransitionAndStartNewGame"
      v-on:playPenaltyGame="handlePlayPenaltyGame"
    ></component>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import webSocket from '@/common/webSocket';
import { ParseResponseMixin, GameMixin, GameMixin2 } from '@/common/mixins/game';
import PostGame from '@/components/home/modals/PostGame';
import SpinWheel from '@/components/home/modals/SpinWheel';
import LevelUp from '@/components/home/modals/LevelUp';
import { Howl } from 'howler';
import shuffle from 'knuth-shuffle-seeded';

const ProgressBar = require('progressbar.js');

export default {
  name: 'game',
  mixins: [ParseResponseMixin, GameMixin, GameMixin2],
  data() {
    return {
      showedSpinModal: false,
      timeIsUp: false,
      currentModal: null,
      showedModal: false,
      userLevel: 0,
      bonusPoints: 0,
      gamesEarned: 0,
      personalizedData: null,
      randomizedAnswers: [],
      playerAnswered: false,
      playerAnswerID: '',
      playerAnswerKey: '',
      cheatUsed: false,
      isFirstTimeUsingCheatHelp: false,
      fiftyFiftyUsed: false,
      isFirstTimeUsingFiftyFiftyHelp: false,
      currentQuestionID: -1,
      availableAnswers: [],
      bothPlayersAnswered: false,
      secondsElapsed: 0,
      timer: null,
      stompClient: null,
      subscription1: null,
      subscription2: null,
      displayedAnswerTime: null,
      // TODO implement playing of all sounds
      selectSound: new Howl({
        src: ['static/sounds/Select_Answer.ogg', 'static/sounds/Select_Answer.mp3'],
      }),
      rightAnswerSound: new Howl({
        src: ['static/sounds/right_answer.ogg', 'static/sounds/right_answer.mp3'],
      }),
      wrongAnswerSound: new Howl({
        src: ['static/sounds/wrong_answer.ogg', 'static/sounds/wrong_answer.mp3'],
      }),
      countDownTimerSound: new Howl({
        src: ['static/sounds/CountDownTimer.ogg', 'static/sounds/CountDownTimer.mp3'],
      }),
      gameWonSound: new Howl({
        src: ['static/sounds/GameWin.ogg', 'static/sounds/GameWin.mp3'],
      }),
      gameLostSound: new Howl({
        src: ['static/sounds/LoseGame.ogg', 'static/sounds/LoseGame.mp3'],
      }),
    };
  },
  created() {
    // console.clear();
    console.log('in Game created hook');
    this.stompClient = webSocket.getGameStompClient();
    console.log('this.stompClient:', this.stompClient);
    this.initQuestionData();
    this.getNextCTA();
    this.getThemesForNextRound();
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channels
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.stopTimer();
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'setHomePlayerAnswer',
      'setAwayPlayerAnswer',
      'updateAddOnGameData',
    ]),
    ...mapMutations('profile', [
      'setShowmodalForLevelUp',
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
    ]),
    stompFailure(error) {
      console.log(error);
      window.location.reload();
    },
    initAndStartTimer() {
      clearInterval(this.timer);
      this.onlyOneCicle = true;
      this.secondsElapsed = 0;
      this.timesForThisRound();
      this.displayedAnswerTime = this.questionAnswerTime;
      /* eslint-disable */
      this.$nextTick(() => {
        this.timer = setInterval(() => {
          if (this.onlyOneCicle) {
            this.onlyOneCicle = false;
            $("#container").html("");
            const bar = new ProgressBar.Circle(container, {
              vm: this,
              color: '#aaa',
              // This has to be the same size as the maximum width to
              // prevent clipping
              strokeWidth: 10,
              trailWidth: 0,
              easing: 'easeInOut',
              duration: this.questionAnswerTime,
              text: {
                autoStyleContainer: false
              },
              from: { color: '#00ac49', width: 10 },
              to: { color: '#E64C3B', width: 10 },
              // Set default step function for all animate calls
              step: function (state, circle) {

                circle.path.setAttribute('stroke', state.color);
                circle.path.setAttribute('stroke-width', state.width);

                var value = Math.round(circle.value() * 100);
//              if (value === 0) {
//                circle.setText(circle._opts.vm.displayedAnswerTime / 1000);
//                circle.path.setAttribute('stroke', '#ff0000');
//              } else if (value < 25) {
//                circle.setText(circle._opts.vm.displayedAnswerTime / 1000);
//                circle.path.setAttribute('stroke', '#0000ff');
//              }
                circle.setText(circle._opts.vm.displayedAnswerTime / 1000);
              }
            }); // var bar
//        <!-- https://github.com/vue-bulma/progress-bar/blob/master/src/ProgressBar.vue-->
//        <!-- http://progressbarjs.readthedocs.io/en/1.0.0/ -->
//        <!-- https://jsfiddle.net/kimmobrunfeldt/72tkyn40/ -->
//          bar.text.style.fontFamily = '"Raleway", Helvetica, sans-serif';
//          bar.text.style.fontSize = '2rem';
            bar.animate(1.0);
          }
          this.secondsElapsed += 1;
          this.displayedAnswerTime -= 1000;
          if ((this.secondsElapsed * 1000)=== this.questionAnswerTime) {
            this.timeIsUp = true;
            clearInterval(this.timer);
          }
        },1000);
      });
      /* eslint-enable */
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    getNextCTA() {
      console.info(`Subscribing to channel: /topic/ctaSelected/${this.gameID}`);
      this.subscription1 = this.stompClient.subscribe(`/topic/ctaSelected/${this.gameID}`, (response) => {
        console.log('[Game] Inside ctaSelected response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        // backend reports failure (e.g. LSC error) — redirect to home so user is not stuck
        if (responseBody.responseEnum && responseBody.responseEnum !== 'OPERATION_SUCCESS') {
          console.log(`[Game] Server reported error (${responseBody.responseEnum}), redirecting to home`);
          this.normalTransition = true;
          this.$router.push('/home');
          return;
        }
        const responseData = responseBody.data;
        console.log('responseData:', responseData);
        if (responseData.gameStateEnum === 'DISPLAY_CTA_TO_BE_ANSWERED' || responseData.gameStateEnum === 'SHOW_GAME_ROUND_END') {
          this.saveQuestionData(responseData);
          clearInterval(this.timer);
        } else if (!this.gameIsResuming && responseData.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          this.normalTransition = true;
          this.saveQuestionDataForNextQuestion(responseData);
          this.initQuestionData();
        }
      });
    },
    getThemesForNextRound() {
      console.info(`Subscribing to channel: /topic/categoriesFetched/${this.gameID}`);
      this.subscription2 = this.stompClient.subscribe(`/topic/categoriesFetched/${this.gameID}`, (response) => {
        console.log('[Game] Inside categoriesFetched response');
        // parse server response and return if any errors occur
        const responseData = this.parseServerResponse(response.body);
        if (responseData === null) {
          return;
        }
        console.log('responseData:', responseData);
        if (responseData.gameStateEnum === 'GAME_FINISHED') {
          this.subscription1.unsubscribe();
          this.subscription2.unsubscribe();
          this.saveRoundData(responseData);
          this.normalTransition = true;
          setTimeout(() => {
            this.currentModal = PostGame;
            console.log('showing post game modal...');
            this.showHideModal();
          }, 5000);
        }
      });
    },
    initQuestionData() {
      console.log('initializing question data...');
      console.log('this.currentQuestionNumber:', this.currentQuestionNumber);
      console.log('this.currentRoundNumber:', this.currentRoundNumber);
      // init common data
      this.playerAnswered = false;
      this.playerAnswerKey = '';
      this.bothPlayersAnswered = false;
      this.personalizedData = this.isHomePlayer ? this.homePlayerQuestionDTO : this.awayPlayerQuestionDTO;
      this.cheatUsed = this.isHomePlayer ? this.homePlayerCheatHelpUsed : this.awayPlayerCheatHelpUsed;
      this.fiftyFiftyUsed = this.isHomePlayer ? this.homePlayerFiftyFiftyHelpUsed : this.awayPlayerFiftyFiftyHelpUsed;
      console.log('this.personalizedData:', this.personalizedData);
      // first sort answers the same way for both players
      this.randomizedAnswers = this.personalizedData.answerDTOList.slice(0).sort((a, b) => a.answerKey - b.answerKey);
      const seed = (this.gameID * (this.currentQuestionNumber + 1)) / this.currentRoundNumber;
      // using Fisher Yates shuffle algorithm, generate a new shuffled array with the answers
      // but with the same ordering for both players (using a seed)
      shuffle(this.randomizedAnswers, seed);
      this.setHomePlayerAnswer('');
      this.setAwayPlayerAnswer('');
      // init help data
      this.cheatUsed = this.isHomePlayer ? this.homePlayerCheatHelpUsed : this.awayPlayerCheatHelpUsed;
      this.fiftyFiftyUsed = this.isHomePlayer ? this.homePlayerFiftyFiftyHelpUsed : this.awayPlayerFiftyFiftyHelpUsed;
      this.isFirstTimeUsingCheatHelp = false;
      this.isFirstTimeUsingFiftyFiftyHelp = false;
      this.availableAnswers = [];
      this.normalTransition = false;
      this.timeIsUp = false;
      console.log('calling initAndStartTimer()...');
      this.initAndStartTimer();
    },
    timesForThisRound() {
      this.questionAnswerTime = this.roundTimeList[0];
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.randomizedAnswers.slice(0, this.randomizedAnswers.length / 2);
      }
      return this.randomizedAnswers.slice(this.randomizedAnswers.length / 2);
    },
    registerUserAnswer(answerID, answerKey) {
      console.log('--> inside registerUserAnswer...');
      console.log('this.currentQuestionNumber:', this.currentQuestionNumber);
      console.log('this.playerAnswered:', this.playerAnswered);
      console.log('this.isFirstTimeUsingCheatHelp:', this.isFirstTimeUsingCheatHelp);
      console.log('this.isFirstTimeUsingFiftyFiftyHelp:', this.isFirstTimeUsingFiftyFiftyHelp);
      if (!this.playerAnswered && (this.currentQuestionNumber < this.numberOfQuestionsPerRound)) {
        if (this.isFirstTimeUsingCheatHelp && !this.availableAnswers.includes(answerID)) {
          return;
        }
        if (this.isFirstTimeUsingFiftyFiftyHelp && !this.availableAnswers.includes(answerID)) {
          return;
        }
        if (this.isHomePlayer) {
          console.log(`user ${this.playersDetails.homePlayerUsername} has answered with answer ${answerKey}...`);
          this.setHomePlayerAnswer(answerKey);
        } else {
          console.log(`user ${this.playersDetails.awayPlayerUsername} has answered with answer ${answerKey}...`);
          this.setAwayPlayerAnswer(answerKey);
        }
        if (this.soundsOn) {
          this.selectSound.play();
        }
        this.playerAnswered = true;
        this.playerAnswerID = answerID;
        this.playerAnswerKey = answerKey;
        clearInterval(this.timer);
        // eslint-disable-next-line
        $("#container").html("");
        console.log('sending player answer');
        this.$axios({
          url: `api/sendSelectedCta2?gameId=${this.gameID}&answer=${this.playerAnswerKey}&questionID=${this.personalizedData.questionId}&useBoost=`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).catch((error) => {
          console.log(`Invoking api/sendSelectedCta2 failed with the following error: ${error}`);
        });
      }
    },
    useCheatHelp() {
      if (this.playerAnswered || this.cheatUsed) {
        console.log(`player ${this.userDetails.username} has already used his/her cheat help!`);
        return;
      }
      if (this.soundsOn) {
        this.selectSound.play();
      }
      this.checkHelpAvailabilityAndGetAnswers('CHEAT');
      this.isFirstTimeUsingCheatHelp = true;
      this.cheatUsed = true;
      this.currentQuestionID = this.personalizedData.questionId;
      console.log('this.currentQuestionID', this.currentQuestionID);
    },
    useFiftyFiftyHelp() {
      if (this.cheatUsed && this.currentQuestionID === this.personalizedData.questionId) {
        console.log(`player ${this.userDetails.username} has used his/her cheat help for the same question!`);
        return;
      }
      if (this.playerAnswered || this.fiftyFiftyUsed) {
        console.log(`player ${this.userDetails.username} has already used his/her 50/50 help!`);
        return;
      }
      if (this.soundsOn) {
        this.selectSound.play();
      }
      this.checkHelpAvailabilityAndGetAnswers('FIFTY_FIFTY');
      this.isFirstTimeUsingFiftyFiftyHelp = true;
      this.fiftyFiftyUsed = true;
    },
    checkHelpAvailabilityAndGetAnswers(helpType) {
      const apiCallPart1 = `api/requestCheatForAnswers?msisdn=${this.userDetails.msisdn}&gameID=${this.gameID}&helpType=${helpType}`;
      const apiCallPart2 = `&answer_1_ID=${this.personalizedData.answerDTOList[0].answerId}&answer_2_ID=${this.personalizedData.answerDTOList[1].answerId}`;
      const apiCallPart3 = `&answer_3_ID=${this.personalizedData.answerDTOList[2].answerId}&answer_4_ID=${this.personalizedData.answerDTOList[3].answerId}`;
      console.log(apiCallPart1 + apiCallPart2 + apiCallPart3);
      this.$axios({
        url: apiCallPart1 + apiCallPart2 + apiCallPart3,
        method: 'GET',
        headers: {
          Authorization: this.jwtInVuex,
        },
      }).then((response) => {
        this.availableAnswers = response.data.data.availableAnswers;
        console.log('availableAnswers', this.availableAnswers);
      }).catch((error) => {
        console.log(`Invoking api/requestCheatForAnswers failed with the following error: ${error}`);
      });
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
    getAwayPlayerAnswersHistory(answerIndex) {
      const awayPlayerAnswersHistory = this.awayPlayerCorrectAnswersCSSClasses[answerIndex];
      return awayPlayerAnswersHistory !== undefined ? awayPlayerAnswersHistory : '';
    },
    getAnswerCSSClasses(answer) {
      const classes = ['btn'];
      if (this.bothPlayersAnswered && (answer.answerId === this.correctAnswerID)) {
        classes.push('correct');
      }
      if ((!this.bothPlayersAnswered && (this.isFirstTimeUsingCheatHelp || this.isFirstTimeUsingFiftyFiftyHelp) && !this.availableAnswers.includes(answer.answerId)) || (this.displayedAnswerTime === 0 && !this.bothPlayersAnswered)) {
        classes.push('rejected');
      }
      return classes;
    },
    showHideModal() {
      this.$nextTick(() => {
        // eslint-disable-next-line
        $('.modal,.modal-overlay').fadeIn(200);
        if (this.soundsOn) {
          if (this.isGameWinner) {
            this.gameWonSound.play();
          } else {
            this.gameLostSound.play();
          }
        }
        /* eslint-disable */
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          console.log('RoundEnded' + this.userLeveledUp + this.showedModal);
          /* eslint-enable */
          if (this.userLeveledUp && !this.showedModal) {
            const notificationLevelupData = {
              userLevel: this.isHomePlayer ? this.homePlayerLevel : this.awayPlayerLevel,
              bonusPoints: this.isHomePlayer ? this.homePlayerLevelUpBonusPoints : this.awayPlayerLevelUpBonusPoints,
              gamesEarned: this.isHomePlayer ? this.homePlayerGamesEarned : this.awayPlayerGamesEarned,
            };
            console.log(`We have a special Notification ${notificationLevelupData}`);
            console.log(`We have a special Notification type with DATA: ${notificationLevelupData.userLevel}`);
            this.setShowmodalForLevelUp({ notificationLevelupObject: notificationLevelupData });
            this.getUserLoginDetails().then(() => {
              this.currentModal = LevelUp;
              this.showedModal = true;
              console.log('showing level up pop up');
              this.showHideModal();
            });
          } else if (this.spinWheelInfo.showSpinWheel && !this.showedSpinModal) {
            this.setNotificationRewardId({ value: this.spinWheelInfo.correlationId });
            this.setNotificationRewardName({ value: this.spinWheelInfo.prizeName });
            this.setNotificationPrizeWon({ value: this.spinWheelInfo.hasWon });
            this.currentModal = SpinWheel;
            this.showedSpinModal = true;
            this.showHideModal();
          } else {
            console.log('user has not leveled up, going to home page');
            this.currentModal = null;
            if (this.getUserAvailableGames === 0) {
              sessionStorage.removeItem('zeroBalancePopUp');
            }
            this.getUserLoginDetails().then(() => {
              this.$router.push('/home');
            });
          }
        });
      });
    },
    updateNormalTransitionAndStartNewGame() {
      console.log('New Game button of post game pop up clicked');
      this.normalTransition = true;
      this.$router.push('/searchingOpponent');
    },
    handlePlayPenaltyGame () {
      this.normalTransition = true;

      this.updateAddOnGameData({
        gameId: this.gameID,
        correctAnswers: this.homePlayerCorrectAnswersCSSClasses.filter(answer => answer === 'correct').length,
      });

      this.$router.push({name: 'penaltyPreGame'});
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'roundTimeList',
      'userDetails',
      'soundsOn',
    ]),
    ...mapState('game', [
      'spinWheelInfo',
      'numberOfQuestionsPerRound',
      'gameIsResuming',
      'gameID',
      'playersDetails',
      'currentRoundNumber',
      'currentQuestionNumber',
      'correctAnswerID',
      'homePlayerCurrentSelectedTheme',
      'homePlayerRoundScore',
      'homePlayerQuestionDTO',
      'homePlayerCheatHelpUsed',
      'homePlayerFiftyFiftyHelpUsed',
      'homePlayerAnswer',
      'homePlayerCorrectAnswersCSSClasses',
      'homeCorrectAnswers',
      'awayCorrectAnswers',
      'awayPlayerRoundScore',
      'awayPlayerQuestionDTO',
      'awayPlayerCheatHelpUsed',
      'awayPlayerFiftyFiftyHelpUsed',
      'awayPlayerAnswer',
      'awayPlayerCorrectAnswersCSSClasses',
      'homePlayerLevel',
      'awayPlayerLevel',
      'awayPlayerLevelUpBonusPoints',
      'homePlayerLevelUpBonusPoints',
      'homePlayerGamesWon',
      'homePlayerGamesEarned',
      'awayPlayerGamesEarned',
      'awayPlayerGamesWon',
      'userLeveledUp',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
      'isGameWinner',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    getQuestionImage() {
      return {
        backgroundImage: `url(${this.bothPlayersAnswered ? this.personalizedData.answerImageURL : this.personalizedData.imageURL})`,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/Game.vue